// Shared Education Block (Slides 1-7) - applies to ALL athletic movements
export const educationBlock = [
  {
    id: 1,
    section: "education",
    title: "NEWTON + DARWIN = ATHLETICISM",
    subtitle: "The Science Behind Athletic Performance",
    author: "By Sachin McDonnell, B.S Exercise Science, NSCA-CSCS",
    type: "title_slide",
    image: "https://images.pexels.com/photos/3763873/pexels-photo-3763873.jpeg",
  },
  {
    id: 2,
    section: "education",
    title: "SACHIN MCDONNELL",
    type: "intro_slide",
    credentials: [
      { label: "Owner", value: "Maximum Sports Conditioning & Paladin Health and Human Performance" },
      { label: "Education", value: "Bachelor of Science in Exercise Science" },
      { label: "Certification", value: "NSCA - Certified Strength and Conditioning Specialist (CSCS)" },
      { label: "Certification", value: "Reflexive Performance Reset Level 2" },
      { label: "Experience", value: "Dozens of Athletic Development Certifications" },
    ],
  },
  {
    id: "rolf-1",
    section: "education",
    title: "ROLF OHMAN",
    type: "video_slide",
    video: "https://customer-assets.emergentagent.com/job_be368375-348c-46dd-a42a-196f5fac9958/artifacts/b7n20akx_AAD0667F-9EB1-49A1-85C2-C4390FC9B0F6.mp4",
    bullets: [
      "World/Olympic Sprints, Jumps, and Throws Coach",
      "Inventor of 1080 Technology",
      "Helped coach Su Bingtian in 2021 Olympics",
    ],
  },
  {
    id: "evans-1",
    section: "education",
    title: "JOHN EVANS",
    type: "video_slide",
    video: "https://customer-assets.emergentagent.com/job_be368375-348c-46dd-a42a-196f5fac9958/artifacts/ykfz6rdd_0C749DDB-8D97-47BD-B7AB-E17F243FA267%202.mp4",
    bullets: [
      "World Class Dunk Coach",
      "Coaches 4 of the 6 highest jumpers in the world",
    ],
  },
  {
    id: 3,
    section: "education",
    title: "BIOLOGY FOUNDATION",
    type: "biology_slide",
    image: "https://images.unsplash.com/photo-1745758278377-2b42af378614?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHwxfHxDaGFybGVzJTIwRGFyd2luJTIwcG9ydHJhaXQlMjBWaWN0b3JpYW4lMjBzY2llbnRpc3R8ZW58MHx8fHwxNzc0MTE1MjYzfDA&ixlib=rb-4.1.0&q=85",
    bullets: [
      { gene: "Muscle Fiber Type", desc: "Some are born with more fast-twitch fibers for explosive power" },
      { gene: "Body Structure", desc: "Limb length, joint angles, and leverage affect movement efficiency" },
      { gene: "Recovery Rate", desc: "How quickly you adapt and rebuild after training" },
      { gene: "Trainability", desc: "How responsive your body is to different types of training" },
    ],
    keyLine: "Genetics set the starting point — training determines the destination.",
  },
  {
    id: 4,
    section: "education",
    title: "PHYSICS FOUNDATION",
    type: "physics_slide",
    image: "https://upload.wikimedia.org/wikipedia/commons/3/3b/Portrait_of_Sir_Isaac_Newton%2C_1689.jpg",
    formulas: [
      { formula: "F = ma", label: "FORCE = mass × acceleration" },
      { formula: "P = F × v", label: "POWER = FORCE × VELOCITY" },
    ],
    bullets: [
      "FORCE drives ACCELERATION",
      "VELOCITY is the outcome",
      "POWER is how fast FORCE is applied",
    ],
    keyLine: "ACCELERATION is FORCE. Top speed is VELOCITY.",
  },
  {
    id: 4,
    section: "education",
    title: "PHYSICS → TRAINING",
    type: "bento_slide",
    bullets: [
      { title: "Strength", desc: "Increases FORCE production" },
      { title: "Power", desc: "Improves rate of FORCE development" },
      { title: "Elasticity", desc: "Preserves FORCE through the system" },
    ],
    keyLine: "If FORCE is low, speed is capped.",
  },
  {
    id: 4,
    section: "education",
    title: "GENETICS (POTENTIAL)",
    type: "split_slide",
    image: "https://images.unsplash.com/photo-1633167606207-d840b5070fc2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzJ8MHwxfHNlYXJjaHwxfHxETkElMjBoZWxpeCUyMGdlbmV0aWNzJTIwc2NpZW5jZSUyMGRhcmslMjBiYWNrZ3JvdW5kfGVufDB8fHx8MTc3NTkzNDA2OHww&ixlib=rb-4.1.0&q=85",
    bullets: [
      "ACTN3 → fast-twitch fibers",
      "ACE → power vs endurance bias",
      "MSTN → muscle growth ceiling",
      "COL1A1 / COL5A1 → tendon stiffness",
    ],
    keyLine: "Genetics set the starting point, not the outcome.",
  },
  {
    id: 5,
    section: "education",
    title: "EPIGENETICS (EXPRESSION)",
    type: "split_slide",
    image: "https://images.unsplash.com/photo-1593538388694-5fbd052e5f1b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjd8MHwxfHNlYXJjaHwyfHxncm91cCUyMGNyb3NzZml0JTIwd29tZW4lMjBiYXJiZWxsJTIwY2xhc3MlMjB3b3Jrb3V0fGVufDB8fHx8MTc3NTkzNDM1Mnww&ixlib=rb-4.1.0&q=85",
    bullets: [
      "Training changes gene expression",
      "Strength increases FORCE capacity",
      "Plyometrics improve elastic response",
      "Sprinting improves neural timing",
    ],
    keyLine: "Your training determines what your body becomes.",
  },
  {
    id: 6,
    section: "education",
    title: "SYSTEM INTEGRATION",
    type: "bento_slide",
    bullets: [
      { title: "Physics", desc: "The rules of movement" },
      { title: "Genetics", desc: "Your potential ceiling" },
      { title: "Epigenetics", desc: "How potential is expressed" },
      { title: "Training", desc: "The outcome you create" },
    ],
    keyLine: "Speed is physics applied through biology.",
  },
  {
    id: 7,
    section: "education",
    title: "THE PYRAMID",
    type: "hierarchy_slide",
    items: [
      { level: 1, title: "STRENGTH", desc: "FORCE production" },
      { level: 2, title: "RATE OF FORCE", desc: "POWER development" },
      { level: 3, title: "ELASTICITY", desc: "FORCE reuse" },
      { level: 4, title: "TECHNIQUE", desc: "Application" },
    ],
    keyLine: "Everything sits on top of strength.",
  },
];

// SPEED Branch
export const speedBranch = [
  {
    id: "speed-1",
    section: "speed",
    branch: "speed",
    title: "MOST ATHLETES TRAIN SPEED WRONG",
    subtitle: "Section 2: Speed",
    type: "title_slide",
    image: "https://images.pexels.com/photos/3760259/pexels-photo-3760259.jpeg",
    bullets: [
      "Not about moving faster",
      "About applying FORCE better",
    ],
  },
  {
    id: "speed-2",
    section: "speed",
    branch: "speed",
    title: "THE CORE MODEL",
    type: "stat_slide",
    formulas: [
      { formula: "FORCE", label: "Drives ACCELERATION" },
      { formula: "VELOCITY", label: "Defines top speed" },
      { formula: "POWER", label: "Connects FORCE and speed" },
    ],
    keyLine: "VELOCITY is the outcome. FORCE is the driver.",
  },
  {
    id: "speed-3",
    section: "speed",
    branch: "speed",
    title: "STRENGTH IS THE BACKBONE",
    type: "split_slide",
    image: "https://images.pexels.com/photos/4720794/pexels-photo-4720794.jpeg",
    bullets: [
      "More FORCE = better projection",
      "Better projection = faster ACCELERATION",
      "Squat, split squat, isometric holds",
    ],
    keyLine: "ACCELERATION is a strength problem first.",
  },
  {
    id: "speed-4",
    section: "speed",
    branch: "speed",
    title: "THE ELASTIC SYSTEM",
    type: "video_slide",
    video: "https://videos.pexels.com/video-files/8533476/8533476-uhd_2560_1440_25fps.mp4",
    bullets: [
      "Max speed requires very short ground contact",
      "Must reuse FORCE, not recreate it",
      "Tendon stiffness + reflex contribution",
    ],
    keyLine: "Elasticity doesn't create FORCE—it preserves it.",
  },
  {
    id: "speed-5",
    section: "speed",
    branch: "speed",
    title: "SPRINT PHASES",
    type: "phases_slide",
    phases: [
      {
        name: "ACCELERATION",
        desc: "Push backward (FORCE dominant)",
        icon: "push",
      },
      {
        name: "MAX VELOCITY",
        desc: "Strike downward (elastic dominant)",
        icon: "strike",
      },
    ],
  },
  {
    id: "speed-6",
    section: "speed",
    branch: "speed",
    title: "ATHLETE TYPES",
    type: "bento_slide",
    bullets: [
      { title: "Elastic Dominant", desc: "Bouncy, reactive, top-end speed" },
      { title: "Strength Dominant", desc: "Powerful, strong ACCELERATION" },
      { title: "Elite Athletes", desc: "Have BOTH qualities" },
    ],
  },
  {
    id: "speed-7",
    section: "speed",
    branch: "speed",
    title: "COMMON MISTAKES",
    type: "mistakes_slide",
    mistakes: [
      "No strength base",
      "Too much conditioning",
      "No elastic progression",
      "Sprinting while fatigued",
    ],
  },
  {
    id: "speed-8",
    section: "speed",
    branch: "speed",
    title: "TESTING BRIDGE",
    type: "testing_slide",
    tests: [
      { name: "10 YARD SPRINT", measures: "FORCE / ACCELERATION" },
      { name: "FLYING 10", measures: "VELOCITY / Elastic ability" },
    ],
    keyLine: "We're not guessing—we're measuring.",
  },
  {
    id: "speed-9",
    section: "speed",
    branch: "speed",
    title: "TIME TO TEST",
    subtitle: "10 Yard Sprint & Flying 10",
    type: "closing_slide",
    quote: "You cannot express FORCE you don't have, and you cannot use it fast without the right system.",
  },
];

// JUMPS Branch
export const jumpsBranch = [
  {
    id: "jumps-1",
    section: "jumps",
    branch: "jumps",
    title: "MOST ATHLETES TRAIN JUMPS WRONG",
    subtitle: "Section 2: Vertical & Horizontal Power",
    type: "title_slide",
    image: "https://images.pexels.com/photos/7675409/pexels-photo-7675409.jpeg",
    bullets: [
      "Not about jumping more",
      "About producing FORCE faster",
    ],
  },
  {
    id: "jumps-2",
    section: "jumps",
    branch: "jumps",
    title: "THE CORE MODEL",
    type: "stat_slide",
    formulas: [
      { formula: "IMPULSE", label: "FORCE × Time = Change in momentum" },
      { formula: "RFD", label: "Rate of FORCE Development" },
      { formula: "HEIGHT", label: "h = V² / 2g" },
    ],
    keyLine: "Jump height is determined by how much FORCE you produce before leaving the ground.",
  },
  {
    id: "jumps-3",
    section: "jumps",
    branch: "jumps",
    title: "STRENGTH IS THE FOUNDATION",
    type: "split_slide",
    image: "https://images.pexels.com/photos/4720794/pexels-photo-4720794.jpeg",
    bullets: [
      "Stronger legs = higher FORCE ceiling",
      "Squat, trap bar deadlift, and single-leg strength elevate the FORCE side of the POWER equation",
      "The stronger you are, the more potential you have to jump high",
      "Strength Standards: Full Depth Squat: 2xBW, 1/2 Squat 2.5xBW",
    ],
    keyLine: "You can't express POWER you haven't built.",
  },
  {
    id: "jumps-4",
    section: "jumps",
    branch: "jumps",
    title: "THE ELASTIC SYSTEM",
    type: "video_slide",
    video: "https://customer-assets.emergentagent.com/job_be368375-348c-46dd-a42a-196f5fac9958/artifacts/1byb5zcc_8A329F95-081B-4640-AD66-94A640569F8F.mp4",
    bullets: [
      "Stretch-shortening cycle is critical",
      "Stiff tendons store and release energy",
      "Titin acts like a bungee cord inside muscles for explosive recoil",
      "Countermovement adds 10-20% to jump height",
    ],
    keyLine: "Your tendons are springs. Train them like it.",
  },
  {
    id: "ejm-1",
    section: "jumps",
    branch: "jumps",
    title: "EJM: ESSENTIAL JUMP MASTERY",
    type: "bento_slide",
    bullets: [
      { title: "Two Foot High Jump", desc: "Long to Short" },
      { title: "One Foot High Jump", desc: "Long to Short" },
      { title: "One Foot Long Jump", desc: "Long to Long" },
    ],
    keyLine: "Master the fundamentals. Everything else is built on these.",
  },
  {
    id: "jumps-5",
    section: "jumps",
    branch: "jumps",
    title: "JUMP PHASES",
    type: "phases_slide",
    phases: [
      {
        name: "LOADING",
        desc: "Eccentric absorption (store energy)",
        icon: "push",
      },
      {
        name: "EXPLOSION",
        desc: "Concentric drive (release POWER)",
        icon: "strike",
      },
    ],
  },
  {
    id: "jumps-6",
    section: "jumps",
    branch: "jumps",
    title: "ATHLETE TYPES",
    type: "bento_slide",
    bullets: [
      { title: "Reactive Jumpers", desc: "Quick, bouncy, rely on elastic recoil" },
      { title: "Strength Jumpers", desc: "Slower load, massive FORCE output" },
      { title: "Elite Jumpers", desc: "Blend both qualities seamlessly" },
    ],
  },
  {
    id: "jumps-7",
    section: "jumps",
    branch: "jumps",
    title: "COMMON MISTAKES",
    type: "mistakes_slide",
    mistakes: [
      "Jumping without strength base",
      "Too much volume, not enough intensity",
      "Ignoring single-leg development",
      "Never training depth jumps or reactive work",
    ],
  },
  {
    id: "jumps-8",
    section: "jumps",
    branch: "jumps",
    title: "TESTING BRIDGE",
    type: "testing_slide",
    tests: [
      { name: "VERTICAL JUMP", measures: "POWER / Reactive ability" },
      { name: "BROAD JUMP", measures: "Horizontal FORCE / Hip extension" },
      { name: "APPROACH JUMP", measures: "Elastic transfer / Technique" },
      { name: "RSI", measures: "Ground contact STIFFNESS / Reactive strength" },
    ],
    keyLine: "We're not guessing—we're measuring.",
  },
  {
    id: "jumps-9",
    section: "jumps",
    branch: "jumps",
    title: "TIME TO TEST",
    subtitle: "Vertical, Broad, Approach & RSI",
    type: "closing_slide",
    quote: "The ground is your platform. Push harder, leave faster.",
  },
];

// THROWS/HITTING Branch
export const throwsBranch = [
  {
    id: "throws-1",
    section: "throws",
    branch: "throws",
    title: "MOST ATHLETES TRAIN ROTATION WRONG",
    subtitle: "Section 2: Throws & Hitting",
    type: "title_slide",
    image: "https://images.pexels.com/photos/5184705/pexels-photo-5184705.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    bullets: [
      "Not about arm speed",
      "About FORCE transfer through the chain",
    ],
  },
  {
    id: "throws-2",
    section: "throws",
    branch: "throws",
    title: "THE CORE MODEL",
    type: "stat_slide",
    formulas: [
      { formula: "TORQUE", label: "Rotational FORCE production" },
      { formula: "SEQUENCE", label: "Proximal to distal energy transfer" },
      { formula: "VELOCITY", label: "End result at the hand/bat/ball" },
    ],
    keyLine: "POWER starts from the ground, transfers through the core, exits through the hands.",
  },
  {
    id: "throws-3",
    section: "throws",
    branch: "throws",
    title: "STRENGTH IS THE ENGINE",
    type: "split_slide",
    image: "https://images.pexels.com/photos/4720788/pexels-photo-4720788.jpeg",
    bullets: [
      "Leg drive initiates all rotation",
      "Core stiffness transfers FORCE without leaks",
      "Posterior chain + anti-rotation strength",
    ],
    keyLine: "Weak legs, weak throw. Strong core, clean transfer.",
  },
  {
    id: "throws-4",
    section: "throws",
    branch: "throws",
    title: "THE ELASTIC SYSTEM",
    type: "video_slide",
    video: "https://videos.pexels.com/video-files/5182923/5182923-uhd_1440_2560_25fps.mp4",
    bullets: [
      "Hip-shoulder separation stores elastic energy like a coiled spring",
      "The kinetic chain: Ground → Legs → Hips → Core → Arm → Hand",
      "Each segment accelerates the next — energy leaks at weak links",
    ],
    keyLine: "The chain is only as strong as its weakest link.",
  },
  {
    id: "throws-5",
    section: "throws",
    branch: "throws",
    title: "ROTATIONAL PHASES",
    type: "phases_slide",
    phases: [
      {
        name: "LOAD & SEPARATE",
        desc: "Hip-shoulder separation stores elastic energy",
        icon: "push",
      },
      {
        name: "ROTATE & RELEASE",
        desc: "Sequential uncoiling delivers max VELOCITY",
        icon: "strike",
      },
    ],
  },
  {
    id: "throws-6",
    section: "throws",
    branch: "throws",
    title: "ATHLETE TYPES",
    type: "bento_slide",
    bullets: [
      { title: "Torque Dominant", desc: "Huge separation, elastic whip" },
      { title: "Strength Dominant", desc: "Raw POWER, direct transfer" },
      { title: "Elite Rotators", desc: "Perfect blend of both" },
    ],
  },
  {
    id: "throws-7",
    section: "throws",
    branch: "throws",
    title: "COMMON MISTAKES",
    type: "mistakes_slide",
    mistakes: [
      "All arm, no legs",
      "Weak or unstable core",
      "No hip-shoulder separation",
      "Training only the throw, not the system",
    ],
  },
  {
    id: "throws-8",
    section: "throws",
    branch: "throws",
    title: "TESTING BRIDGE",
    type: "testing_slide",
    tests: [
      { name: "MED BALL ROTATIONAL", measures: "Rotational POWER output" },
      { name: "MED BALL SCOOP TOSS", measures: "Hip extension + transfer" },
    ],
    keyLine: "We're not guessing—we're measuring.",
  },
  {
    id: "throws-9",
    section: "throws",
    branch: "throws",
    title: "TIME TO TEST",
    subtitle: "Med Ball Throws",
    type: "closing_slide",
    quote: "You don't throw with your arm. You throw with your entire body.",
  },
];

// Branch selection data
export const branches = [
  {
    id: "speed",
    title: "SPEED",
    subtitle: "Sprinting & Acceleration",
    description: "10yd Sprint & Flying 10",
    icon: "Zap",
    color: "#D31113",
    slides: speedBranch,
  },
  {
    id: "jumps",
    title: "JUMPS",
    subtitle: "Vertical & Horizontal Power",
    description: "Vertical & Broad Jump",
    icon: "ArrowUp",
    color: "#3B82F6",
    slides: jumpsBranch,
  },
  {
    id: "throws",
    title: "THROWS",
    subtitle: "Rotational Power & Hitting",
    description: "Med Ball Testing",
    icon: "RotateCw",
    color: "#F59E0B",
    slides: throwsBranch,
  },
];

// Legacy export for backward compatibility
export const slidesData = [...educationBlock, ...speedBranch];
